import React from 'react';
import PolicyPageEditor from '../PolicyPageEditor';

const TermsAndConditions = () => (
  <PolicyPageEditor pageType="terms-and-conditions" pageTitle="Terms and Conditions" />
);

export default TermsAndConditions;
